import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(employeeId) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  let customerQueryParams = searchQueryParams;

  let searchQueryEmployeeData = new URLSearchParams({
    ...searchOptions,
    status: 0,
  }).toString();

  if (employeeId) {
    customerQueryParams =
      customerQueryParams +
      "&" +
      new URLSearchParams({ employeeId }).toString();
  }

  // Fetch constant data concurrently
  const [project, employee, bookingEvent, customer, employeeData] =
    await Promise.all([
      clientAPI("get", `/project?${searchQueryParams}`),
      clientAPI("get", `/employee?${searchQueryParams}`),
      clientAPI("get", `/bookingEvent?${searchQueryParams}`),
      clientAPI("get", `/customer?${customerQueryParams}`),
      clientAPI("get", `/employee?${searchQueryEmployeeData}`),
    ]);

  // Index data by 'id' to improve lookup performance
  return {
    project: project?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    employee: employee?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {}
    ),
    bookingEvent: bookingEvent?.items?.reduce(
      // (acc, item) => ({ ...acc, [item._id]: item.name }),
      // {}
      (acc, item) => ({
        ...acc,
        [item._id]: {
          name: item.name,
          code: item.code,
        },
      }),
      {}
    ),
    customer: customer?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name || item.code }),
      {}
    ),
    employeeData: employeeData?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.fullName,
          code: item.code,
        },
      }),
      {}
    ),
  };
}

export function useCategories(employeeId, shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories5", employeeId],
    queryFn: () => fetchConstantData(employeeId),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
